import { useEffect, useState } from "react";
import { getProjects, createProject } from "../services/api";

export default function ProjectSelector({ projectId, setProjectId, setProjectName }) {
  const [projects, setProjects] = useState([]);
  const [newProject, setNewProject] = useState("");
  const [loading, setLoading] = useState(false);

  // 🔹 Load projects
  const loadProjects = async () => {
    try {
      const res = await getProjects();
      setProjects(res.data);

      // auto-select first project
      if (res.data.length > 0 && !projectId) {
        setProjectId(res.data[0].id);
      }
    } catch {
      console.log("Failed to load projects");
    }
  };

  useEffect(() => {
    loadProjects();
  }, []);

  // 🔹 Create project
  const handleCreate = async () => {
    if (!newProject.trim()) return;

    try {
      setLoading(true);
      await createProject(newProject);
      setNewProject("");
      loadProjects(); // refresh
    } catch {
      console.log("Failed to create project");
    }
    setLoading(false);
  };

  return (
    <div className="bg-white p-4 rounded shadow mb-4">

      <h2 className="font-semibold mb-2">Projects</h2>

      {/* Dropdown */}
      <select
        className="border p-2 w-full mb-2"
        value={projectId || ""}
        /*onChange={(e) => setProjectId(Number(e.target.value))}*/
        onChange={(e) => {
        const selected = projects.find(p => p.id == e.target.value);
        setProjectId(e.target.value);
        setProjectName(selected?.name);
        }}

      >
        <option value="">Select Project</option>
        {projects.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>

      {/* Create Project */}
      <div className="flex gap-2">
        <input
          className="border p-2 flex-1"
          placeholder="New project name"
          value={newProject}
          onChange={(e) => setNewProject(e.target.value)}
        />

        <button
          onClick={handleCreate}
          disabled={loading}
          className="bg-blue-500 text-white px-3"
        >
          {loading ? "Adding..." : "Add"}
        </button>
      </div>

    </div>
  );
}